export const convertStringToArray = (input) => {
  let result = input;
  try {
    result = JSON.parse(result);
  } catch (err) {
    console.log("Error in conversion > convertStringToArray=", err);
    result = [];
  }
  // console.log("Result for convertStringToArray=",result);
  return result;
};

export const convertStringToObject = (input) => {
  let result = input;
  try {
    result = JSON.parse(result);
  } catch (err) {
    console.log("Error in conversion > convertStringToObject=", err);
    result = {};
  }
  console.log("Result for convertStringToObject=", result);
  return result;
};

export const getParamValue = (config, param, group = "imtime") => {
  if (!param || !config || !group) return null;
  if (!config.parameterGroups) return null;
  if (!config.parameterGroups[group]) return null;
  if (!config.parameterGroups[group].parameters) return null;
  if (!config.parameterGroups[group].parameters[param]) return null;
  return config.parameterGroups[group].parameters[param].defaultValue.value;
};
